export default "__VITE_ASSET__11f3df43__"